
import "./TestListing.scss";
import { APIResponse, APIStatus } from "@Src/services/baseInterfaces";
import { useEffect, useRef, useState } from "react";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import HomeLayout from "../layout/components/HomeLayout/HomeLayout";
import DetailsPageBanner from "@Components/DetailsPageBanner/DetailsPageBanner";
import { SubscriptionUpdates } from "@Components/SubscriptionUpdates/SubscriptionUpdates";
import { getSearchFilters, getTestList, getTestSeriesList, getTestSeriesListAll, getDifficultyLevels, getTestSeriesListByClass, getChapterList, getTopicList } from "../TestDetails/services/TestDetails.service";
import { getHomeBoardList, getBoardDetails } from "@Components/Header/services/Header.service";
import { getLanguageList, getBoardlist, getClassList } from "../UserProfile/Services/UserProfile.sevice";
import MockTests from "./Components/MockTests/MockTests";
import { FilterIndex } from "../Filter/Filter";
import { FILTER_KEYS, FILTER_LIST, FILTER_KEY_LIST } from "../Filter/Constants/filters.constants";
import { TestSereisRouteURL } from "@Constants/app-route-url.constant";
import { HeaderNameKeys } from "@Constants/app.constant";
import { TestSeriesSkeleton } from "@Components/TestSeriesSkeleton/TestSeriesSkeleton";
import { useAppSelector, useAppDispatch } from "@App/hooks";
import { syncLanguageName } from "@Src/utils/service/language-sync.service";
import SvgIcon from "@Components/icons/SvgIcon";
import { TestSeriesAllFilter } from "../TestSeriesDetails/Components/TestSeriesAllFilter/TestSeriesAllFilter";
import HelmetComponent from "@Src/utils/helmet/HelmetComponent";

export const TestListingIndex = () => {
    const params = useParams();
    const location = useLocation();
    let [searchParams, setSearchParams] = useSearchParams();
    const [isTestSeries, setIsTestSeries] = useState<boolean>(false);
    let classId = params.classId || searchParams.get("classId") || location.state?.classId;
    let className = params.className! || searchParams.get("className")! || location.state?.className;
    let subjectId = params.subjectId || Number(searchParams.get("subjectId")) || location.state?.subjectId;
    let subjectName = params.subjectName! || searchParams.get("subjectName")! || location.state?.subjectName;
    let testSeriesId = params.testSeriesId || searchParams.get("testseriesId") || location.state?.testSeriesId;
    let testSeriesName = params.testSeriesName! || searchParams.get("testseriesName")! || location.state?.testSeriesName;
    const testId = searchParams.get("testId") || location.state?.testId;
    const chapterId = searchParams.get("chapterId") || location.state?.chapterId;
    const topicId = searchParams.get("topicId") || location.state?.topicId;
    const testName = searchParams.get("testName") || location.state?.testName;
    const chapterName = searchParams.get("chapterName") || location.state?.chapterName;
    const topicName = searchParams.get("topicName") || location.state?.topicName;
    let boardId = params.boardId || searchParams.get("boardId") || location.state?.boardId;
    let boardName = params.boardName || searchParams.get("boardName") || location.state?.boardName;
    let skillId = location.state?.skillId;
    let difficultyBasedAccuracy = location.state?.difficultyBasedAccuracy;
    const [topicPriority, setTopicPriority] = useState<any>(location.state?.topicPriority);
    const [testDeatils, setTestDeatils] = useState<Array<any>>([]);
    const [filters, setFilters] = useState<any>({});
    const [initialFilters, setInitialFilters] = useState<Array<any>>([]);
    const [headingsBreadcrumb, setHeadingsBreadcrumb] = useState<Array<any>>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [page, setPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentParams, setCurrentParams] = useState<any>({});
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const isLoadingCoursePreferences = useAppSelector((state: any) => state.coursePreferences);
    const coursePreferences = typeof isLoadingCoursePreferences === 'string' ? JSON.parse(isLoadingCoursePreferences) : isLoadingCoursePreferences;
    const loginData = useAppSelector((state: any) => state.login);
    const dispatch = useAppDispatch();
    const [boardTotals, setBoardTotals] = useState<any>(null);
    const [boardDetailsData, setBoardDetailsData] = useState<any>(null);
    const isInitializedRef = useRef(false);
    const lastBoardIdRef = useRef<any>(null);

    const isPreviousYearPage = location.pathname === TestSereisRouteURL.PREVIOUS_YEAR_MOCK_TEST_SERIES;
    const isDiagnosticPage = location.pathname === TestSereisRouteURL.DIAGNOSTIC_TEST_SERIES;
    const isFullMockPage = location.pathname === TestSereisRouteURL.FULL_MOCK_TEST_SERIES;

    // Generate years from 2003 through the current year for the Previous Year filter
    const examYearList = (() => {
        const currentYear = new Date().getFullYear();
        return Array.from({ length: currentYear - 2001 + 1 }, (_, i) => {
            const year = String(currentYear - i);
            return { Id: year, Name: year };
        });
    })();



    // Auto-sync language name if missing and update filters when language name changes
    useEffect(() => {
        if (loginData?.LanguageId && !loginData?.LanguageName) {
            syncLanguageName(loginData.LanguageId, dispatch);
        }

        // Update filter options when language name becomes available
        if (loginData?.LanguageId && loginData?.LanguageName) {
            setFilters((prev: any) => {
                if (prev[FILTER_LIST.LANGUAGE]) {
                    const updatedLanguages = prev[FILTER_LIST.LANGUAGE].map((l: any) => {
                        if (l.Id == loginData.LanguageId) {
                            return { ...l, Name: loginData.LanguageName };
                        }
                        return l;
                    });
                    return { ...prev, [FILTER_LIST.LANGUAGE]: updatedLanguages };
                }
                return prev;
            });

            // Also update initial filters
            setInitialFilters((prev: any) => {
                return prev.map((f: any) => {
                    if (f[FILTER_KEYS.LANGUAGE]) {
                        return {
                            [FILTER_KEYS.LANGUAGE]: [{ Id: loginData.LanguageId, Name: loginData.LanguageName }]
                        };
                    }
                    return f;
                });
            });
        }
    }, [loginData?.LanguageId, loginData?.LanguageName, dispatch]);

    // Fetch global filters (Difficulty, Language, Board)
    useEffect(() => {
        // Fetch Language list for everyone
        getLanguageList().then((response: any) => {
            if (response?.ResponseType === 'SUCCESS') {
                setFilters((prev: any) => ({
                    ...prev,
                    [FILTER_LIST.LANGUAGE]: response.data || []
                }));
            }
        }).catch((error) => {
            console.error('Error fetching language list:', error);
        });

        // Fetch Difficulty levels for everyone
        getDifficultyLevels().then((response: any) => {
            if (response?.ResponseType === 'SUCCESS') {
                setFilters((prev: any) => ({
                    ...prev,
                    [FILTER_LIST.DIFFICULTY]: response.data || []
                }));
            }
        }).catch((error) => {
            console.error('Error fetching difficulty levels:', error);
        });

        // Fetch Board list for logged out users
        if (!loginData?.isLoggedIn) {
            getBoardlist().then((response: any) => {
                if (response?.ResponseType === 'SUCCESS') {
                    setFilters((prev: any) => ({
                        ...prev,
                        [FILTER_LIST.BOARD]: response.data || []
                    }));
                }
            }).catch((error) => {
                console.error('Error fetching board list:', error);
            });
        }

        // Populate year list for previous year page
        if (isPreviousYearPage) {
            setFilters((prev: any) => ({
                ...prev,
                [FILTER_LIST.EXAM_YEAR]: examYearList
            }));
        }
    }, [loginData?.isLoggedIn, isPreviousYearPage]);


    useEffect(() => {
        window.scrollTo(0, 0);
        let param: any = {}
        let initialFilters: any = []
        if (classId || subjectId || testId || chapterId || testSeriesId || boardId) { } else {
            const board = coursePreferences?.boardDetails?.[0];
            const classDetail = coursePreferences?.classDetails?.[0];

            if (board?.Id) {
                param[FILTER_KEYS.BOARD] = board.Id;
                initialFilters.push({ [FILTER_KEYS.BOARD]: board });
            }
            if (classDetail?.Id) {
                param[FILTER_KEYS.CLASS] = classDetail.Id;
                initialFilters.push({ [FILTER_KEYS.CLASS]: classDetail });
            }


            if (loginData?.isLoggedIn && loginData?.LanguageId) {
                param.languageId = [loginData.LanguageId];
                const defaultLangName = loginData.LanguageName || 'Language';
                initialFilters.push({ [FILTER_KEYS.LANGUAGE]: { Id: loginData.LanguageId, Name: defaultLangName } });
            }


            // Pre-populate filter lists from coursePreferences so dropdowns have options immediately
            if (coursePreferences?.boardDetails?.length > 0) {
                setFilters((prev: any) => ({
                    ...prev,
                    [FILTER_LIST.BOARD]: coursePreferences.boardDetails
                }));
            }
            if (coursePreferences?.classDetails?.length > 0) {
                setFilters((prev: any) => ({
                    ...prev,
                    [FILTER_LIST.CLASS]: coursePreferences.classDetails
                }));
            }
            if (coursePreferences?.subjectDetails?.length > 0) {
                const isPrevOrFullMock = isPreviousYearPage || isFullMockPage;
                const subjects = isPrevOrFullMock 
                    ? [{ Id: 'ALL', Name: 'All Subject' }, ...coursePreferences.subjectDetails]
                    : coursePreferences.subjectDetails;
                setFilters((prev: any) => ({
                    ...prev,
                    [FILTER_LIST.SUBJECT]: subjects
                }));
            }


            if (location.pathname == TestSereisRouteURL.TEST_SERIES || location.pathname == TestSereisRouteURL.DIAGNOSTIC_TEST_SERIES || location.pathname == TestSereisRouteURL.FULL_MOCK_TEST_SERIES || location.pathname == TestSereisRouteURL.PREVIOUS_YEAR_MOCK_TEST_SERIES) {
                setIsTestSeries(true);
                if (isPreviousYearPage || isFullMockPage) {
                    const allSubjectOption = { Id: 'ALL', Name: 'All Subject' };
                    initialFilters.push({ [FILTER_KEYS.SUBJECT]: allSubjectOption });
                    const allSubjectIds = coursePreferences?.subjectDetails?.map((s: any) => s.Id) || [];
                    if (allSubjectIds.length > 0) {
                        param[FILTER_KEYS.SUBJECT] = allSubjectIds;
                    }
                }
                setInitialFilters(initialFilters);
                // const breadcrumbName = location.pathname === TestSereisRouteURL.DIAGNOSTIC_TEST_SERIES ? 'Readiness Check' : 'Practice Test';
                let breadcrumbName: any;
                switch (window.location.pathname) {
                    case TestSereisRouteURL.DIAGNOSTIC_TEST_SERIES:
                        breadcrumbName = "Readiness Check";
                        break;
                    case TestSereisRouteURL.TEST_SERIES:
                        breadcrumbName = "Practice Test";
                        break;
                    case TestSereisRouteURL.FULL_MOCK_TEST_SERIES:
                        breadcrumbName = "Mock Test";
                        break;
                    case TestSereisRouteURL.PREVIOUS_YEAR_MOCK_TEST_SERIES:
                        breadcrumbName = "Previous Year Test";
                        break;
                    default:
                        breadcrumbName = "Practice Test";
                }
                setHeadingsBreadcrumb([{ name: breadcrumbName, type: HeaderNameKeys.ALL_TEST_SERIES }]);
                // getAllTestSeriesSearchFilters(param, true)
                if (topicPriority) param.topicPriority = topicPriority;
                if (skillId) param.skillId = skillId;
                if (difficultyBasedAccuracy) param.difficultyBasedAccuracy = Number(difficultyBasedAccuracy);
                getAllTestSeriesList(param, 1);
            } else {
                setIsTestSeries(false);
                setInitialFilters(initialFilters);
                getAllSearchFilters(param, true)
                getAllTestList(param);
            }
        }
        if (location.state) {
            window.history.replaceState({}, document.title);
        }
    }, [coursePreferences, loginData, location.pathname, location.state]);


    useEffect(() => {
        window.scrollTo(0, 0);
        setBoardTotals(null);
        let Headings = [];
        if (classId || subjectId || testId || boardId) {
            setIsTestSeries(!!boardId);
            const board = coursePreferences?.boardDetails?.[0];

            let param: any = {
                [FILTER_KEYS.CLASS]: classId,
                [FILTER_KEYS.TEST]: testId,
            }
            if (subjectId) {
                param[FILTER_KEYS.SUBJECT] = subjectId;
            }
            if (board?.Id) {
                param[FILTER_KEYS.BOARD] = board.Id;
            }

            let initialFilters: any = [
                {
                    [FILTER_KEYS.CLASS]: {
                        Id: Number(classId),
                        Name: className
                    }
                },
            ]
            if (subjectId) {
                initialFilters.push({
                    [FILTER_KEYS.SUBJECT]: {
                        Id: Number(subjectId),
                        Name: subjectName
                    }
                });
            }
            // Collect filter data to update state once
            let filterData: any = {};
            if (board?.Id && !boardId) {
                param[FILTER_KEYS.BOARD] = board.Id;
                initialFilters.push({ [FILTER_KEYS.BOARD]: board });
                filterData[FILTER_LIST.BOARD] = [board];
            }
            if (chapterId) {
                param[FILTER_KEYS.CHAPTER] = [Number(chapterId)];
                let chapterData = {
                    [FILTER_KEYS.CHAPTER]: [{
                        Id: Number(chapterId),
                        Name: chapterName
                    }]
                }
                initialFilters.push(chapterData)
            }
            if (topicId) {
                param[FILTER_KEYS.TOPIC] = [Number(topicId)];
                let topicData = {
                    [FILTER_KEYS.TOPIC]: [{
                        Id: Number(topicId),
                        Name: topicName
                    }]
                }
                initialFilters.push(topicData)
            }
            if (boardId) {
                const bId = isNaN(Number(boardId)) ? boardId : Number(boardId);
                param[FILTER_KEYS.BOARD] = bId;
                let boardData = {
                    [FILTER_KEYS.BOARD]: {
                        Id: bId,
                        Name: boardName
                    }
                }
                initialFilters.push(boardData)
                filterData[FILTER_LIST.BOARD] = [boardData[FILTER_KEYS.BOARD]];

                // Fetch board details to get classes
                getBoardDetails({ boardId: bId }).then((response: APIResponse) => {
                    if (response && response.ResponseType === APIStatus.SUCCESS && response.data?.[0]) {
                        const boardInfo = response.data[0];

                        setBoardTotals({
                            totalStudents: boardInfo.total_Students_record_in_Board,
                            totalAttendents: boardInfo.total_Students_AttendedExam_record_in_Board,
                            totalTests: boardInfo.total_Test_record
                        });

                        // Store the full board details data for subject population
                        setBoardDetailsData(boardInfo.result_data);

                        if (boardInfo.result_data) {
                            const classes = boardInfo.result_data.map((item: any) => ({
                                Id: item.ClassId,
                                Name: item.ClassName
                            }));
                            setFilters((prev: any) => ({
                                ...prev,
                                [FILTER_LIST.CLASS]: classes
                            }));
                        }
                    }
                }).catch((error) => {
                    console.error('Error fetching board details:', error);
                });

                // Logic to lock Class and Language if board matches User's Course Preference
                const userBoardId = coursePreferences?.boardDetails?.[0]?.Id;
                if (userBoardId && String(bId) === String(userBoardId)) {
                    // Force Class from Course Preferences
                    const userClass = coursePreferences?.classDetails?.[0];
                    if (userClass) {
                        param[FILTER_KEYS.CLASS] = userClass.Id;
                        // Remove any existing class filter to avoid duplicates
                        initialFilters = initialFilters.filter((f: any) => !Object.keys(f).includes(FILTER_KEYS.CLASS));
                        initialFilters.push({ [FILTER_KEYS.CLASS]: userClass });

                        // Also Add subjectId from preferences if not already selected
                        const subjectIds = coursePreferences?.subjectDetails?.map((s: any) => s.Id) || [];
                        if (subjectIds.length > 0 && !param[FILTER_KEYS.SUBJECT]) {
                            param[FILTER_KEYS.SUBJECT] = subjectIds;
                            // We don't necessarily add all subjects to initialFilters as separate items or array? 
                            // Usually valid initialFilters for subject is one item or array?
                            // The existing logic adds one subject if subjectId exists in URL.
                            // If we want to filter by all subjects of user... 
                            // The backend supports subjectId as array.
                            // But Filter UI for 'Subject' dropdown is single select? 
                            // Filter.ts: 308: placeholder="Subject" className="filter-dropdown" /> : ''} -> Dropdown (Single)
                            // So we probably shouldn't force multiple subjects in param if the UI can't handle it or if it disrupts the "Subject" test.
                            // However, the user request payload example showed: subjectId: [5, 4, 10, 3]
                            // So we should add it to param.
                        }
                    }

                    // Force Language from Login Data
                    if (loginData?.isLoggedIn && loginData?.LanguageId) {
                        param.languageId = [loginData.LanguageId];
                        const defaultLangName = loginData.LanguageName || 'Language';
                        // Remove existing language filter
                        initialFilters = initialFilters.filter((f: any) => !Object.keys(f).includes(FILTER_KEYS.LANGUAGE));
                        initialFilters.push({ [FILTER_KEYS.LANGUAGE]: { Id: loginData.LanguageId, Name: defaultLangName } });
                    }
                }
            }
            // Don't set default language on board pages UNLESS it's the matched board (which is handled above)
            const userBoardIdCheck = coursePreferences?.boardDetails?.[0]?.Id;
            const isSameBoardCheck = userBoardIdCheck && boardId && String(boardId) === String(userBoardIdCheck);

            if (loginData?.isLoggedIn && loginData?.LanguageId && !boardId && !isSameBoardCheck) {
                param.languageId = [loginData.LanguageId];
                const defaultLangName = loginData.LanguageName || 'Language';
                initialFilters.push({ [FILTER_KEYS.LANGUAGE]: { Id: loginData.LanguageId, Name: defaultLangName } });
            }

            // Update filters state with collected data
            if (Object.keys(filterData).length > 0) {
                setFilters((prev: any) => ({ ...prev, ...filterData }));
            }
            if (!isInitializedRef.current || String(boardId) !== String(lastBoardIdRef.current)) {
                setInitialFilters(initialFilters);
                isInitializedRef.current = true;
                lastBoardIdRef.current = boardId;

                if (subjectId && classId && boardId) {
                    const sId = Array.isArray(subjectId) ? subjectId[0] : subjectId;
                    getChapterList({ boardId, classId, subjectId: Number(sId) }).then((response: APIResponse) => {
                        if (response?.ResponseType === APIStatus.SUCCESS) {
                            setFilters((prev: any) => ({ ...prev, [FILTER_LIST.CHAPTER]: response.data || [] }));
                        }
                    }).catch(err => console.error("Error pre-fetching chapters:", err));
                }
                if (chapterId) {
                    const cId = Array.isArray(chapterId) ? chapterId.join(',') : String(chapterId);
                    const params: any = {
                        chapterId: cId
                    };
                    if (boardId) params.boardId = isNaN(Number(boardId)) ? boardId : Number(boardId);
                    if (classId) params.classId = isNaN(Number(classId)) ? classId : Number(classId);
                    if (subjectId) params.subjectId = isNaN(Number(subjectId)) ? subjectId : Number(subjectId);
                    getTopicList(params).then((response: APIResponse) => {
                        if (response?.ResponseType === APIStatus.SUCCESS) {
                            setFilters((prev: any) => ({ ...prev, [FILTER_LIST.TOPIC]: response.data || [] }));
                        }
                    }).catch(err => console.error("Error pre-fetching topics:", err));
                }
            }
            if (boardId) {
                // If on matching board, remove testId from payload to avoid null issue
                if (isSameBoardCheck) {
                    delete param[FILTER_KEYS.TEST];
                }
                setIsTestSeries(true);
                // getAllTestSeriesSearchFilters(param, true)
                if (topicPriority) param.topicPriority = topicPriority;
                if (skillId) param.skillId = skillId;
                if (difficultyBasedAccuracy) param.difficultyBasedAccuracy = Number(difficultyBasedAccuracy);
                getAllTestSeriesList(param, 1);
            } else {
                getAllSearchFilters(param, true)
                getAllTestList(param);
            }

            Headings = [];
            if (boardId) {
                Headings.push({ name: boardName, type: HeaderNameKeys.BOARD, id: boardId });
            }
            // if (className) {
            //     Headings.push({ name: className, type: HeaderNameKeys.CLASS, id: classId });
            // }
            // if (subjectName) {
            //     Headings.push({ name: subjectName, type: HeaderNameKeys.SUBJECT, id: subjectId });
            // }
            // if (testSeriesName) {
            //     Headings.push({ name: testSeriesName, type: HeaderNameKeys.TEST_SERIES, id: testSeriesId });
            // }


            setHeadingsBreadcrumb(location.state?.boardId ? [{ name: "Practice Test", type: HeaderNameKeys.BOARD, id: boardId }] : Headings)
        }
    }, [classId, subjectId, testId, chapterId, boardId, coursePreferences, loginData]);

    useEffect(() => {
        window.scrollTo(0, 0);
        setBoardTotals(null);
        let Headings = [];
        if (testSeriesId) {
            setIsTestSeries(true);
            const board = coursePreferences?.boardDetails?.[0];
            const classDetail = coursePreferences?.classDetails?.[0];

            let param: any = {
                [FILTER_KEYS.TEST_SERIES]: Number(testSeriesId),
            }
            let initialFilters: any = [
                {
                    [FILTER_KEYS.TEST_SERIES]: {
                        Id: Number(testSeriesId),
                        Name: testSeriesName
                    }
                },
            ]

            let filterData: any = {};
            if (board?.Id) {
                param[FILTER_KEYS.BOARD] = board.Id;
                initialFilters.push({ [FILTER_KEYS.BOARD]: board });
                filterData[FILTER_LIST.BOARD] = [board];
            }

            if (classDetail?.Id) {
                param[FILTER_KEYS.CLASS] = classDetail.Id;
                initialFilters.push({ [FILTER_KEYS.CLASS]: classDetail });
                filterData[FILTER_LIST.CLASS] = [classDetail];
            }

            if (Object.keys(filterData).length > 0) {
                setFilters((prev: any) => ({ ...prev, ...filterData }));
            }

            if (loginData?.isLoggedIn && loginData?.LanguageId) {
                param.languageId = [loginData.LanguageId];
                const defaultLangName = loginData.LanguageName || 'Language';
                initialFilters.push({ [FILTER_KEYS.LANGUAGE]: { Id: loginData.LanguageId, Name: defaultLangName } });
            }

            setInitialFilters(initialFilters);

            if (subjectId && classId && boardId) {
                const sId = Array.isArray(subjectId) ? subjectId[0] : subjectId;
                getChapterList({ boardId, classId, subjectId: Number(sId) }).then((response: APIResponse) => {
                    if (response?.ResponseType === APIStatus.SUCCESS) {
                        setFilters((prev: any) => ({ ...prev, [FILTER_LIST.CHAPTER]: response.data || [] }));
                    }
                }).catch(err => console.error("Error pre-fetching chapters:", err));
            }
            if (chapterId) {
                const cId = Array.isArray(chapterId) ? chapterId.join(',') : String(chapterId);
                const params: any = {
                    chapterId: cId
                };
                if (boardId) params.boardId = isNaN(Number(boardId)) ? boardId : Number(boardId);
                if (classId) params.classId = isNaN(Number(classId)) ? classId : Number(classId);
                if (subjectId) params.subjectId = isNaN(Number(subjectId)) ? subjectId : Number(subjectId);
                getTopicList(params).then((response: APIResponse) => {
                    if (response?.ResponseType === APIStatus.SUCCESS) {
                        setFilters((prev: any) => ({ ...prev, [FILTER_LIST.TOPIC]: response.data || [] }));
                    }
                }).catch(err => console.error("Error pre-fetching topics:", err));
            }

            // getAllTestSeriesSearchFilters(param, true)
            if (topicPriority) param.topicPriority = topicPriority;
            if (skillId) param.skillId = skillId;
            if (difficultyBasedAccuracy) param.difficultyBasedAccuracy = Number(difficultyBasedAccuracy);
            getAllTestSeriesList(param, 1);
            Headings = [
                { name: 'Test Series', type: HeaderNameKeys.ALL_TEST_SERIES },
                { name: testSeriesName, type: HeaderNameKeys.TEST_SERIES, id: testSeriesId }
            ]
            setHeadingsBreadcrumb(Headings)
        }
    }, [testSeriesId, loginData, coursePreferences]);

    function getAllTestList(param: any) {
        getTestList(param).then((response: APIResponse) => {
            if (response?.ResponseType == APIStatus.SUCCESS) {
                let data = response?.data;
                setTestDeatils(data.result);
            }
        })
    }

    function getAllSearchFilters(param: any, updateInitial: boolean = false) {
        getSearchFilters(param).then((response: APIResponse) => {
            if (response?.ResponseType == APIStatus.SUCCESS) {
                let data = response?.data;

                // Merge board list from coursePreferences with API response
                if (coursePreferences?.boardDetails?.length > 0) {
                    const prefBoards = coursePreferences.boardDetails;
                    const apiBoards = data[FILTER_LIST.BOARD] || [];

                    const boardMap = new Map();
                    apiBoards.forEach((b: any) => boardMap.set(b.Id, b));
                    prefBoards.forEach((b: any) => {
                        if (!boardMap.has(b.Id)) {
                            boardMap.set(b.Id, b);
                        }
                    });
                    data[FILTER_LIST.BOARD] = Array.from(boardMap.values());
                }

                // Merge class list from coursePreferences with API response
                if (coursePreferences?.classDetails?.length > 0) {
                    const prefClasses = coursePreferences.classDetails;
                    const apiClasses = data[FILTER_LIST.CLASS] || [];

                    const classMap = new Map();
                    apiClasses.forEach((c: any) => classMap.set(c.Id, c));
                    prefClasses.forEach((c: any) => {
                        if (!classMap.has(c.Id)) {
                            classMap.set(c.Id, c);
                        }
                    });
                    data[FILTER_LIST.CLASS] = Array.from(classMap.values());
                }

                // Merge subject list from coursePreferences with API response
                if (coursePreferences?.subjectDetails?.length > 0) {
                    const prefSubjects = coursePreferences.subjectDetails;
                    const apiSubjects = data[FILTER_LIST.SUBJECT] || [];

                    const subjectMap = new Map();
                    apiSubjects.forEach((s: any) => subjectMap.set(s.Id, s));
                    prefSubjects.forEach((s: any) => {
                        if (!subjectMap.has(s.Id)) {
                            subjectMap.set(s.Id, s);
                        }
                    });
                    data[FILTER_LIST.SUBJECT] = Array.from(subjectMap.values());
                }
                if (updateInitial && loginData?.LanguageId) {
                    const langName = loginData.LanguageName || 'Language';
                    const lang = { Id: loginData.LanguageId, Name: langName };

                    setInitialFilters(prev => prev.map(f =>
                        f[FILTER_KEYS.LANGUAGE] ? { [FILTER_KEYS.LANGUAGE]: lang } : f
                    ));
                }

                // Patch names from master list just in case
                if (data[FILTER_LIST.LANGUAGE] && loginData?.isLoggedIn) {
                    data[FILTER_LIST.LANGUAGE] = data[FILTER_LIST.LANGUAGE].map((l: any) => {
                        const patchedName = l.Name || (l.Id == loginData.LanguageId ? loginData.LanguageName : 'Language');
                        return { ...l, Name: patchedName };
                    });
                } else if (!loginData?.isLoggedIn) {
                    // For logged out users, don't use API language data, use our own
                    delete data[FILTER_LIST.LANGUAGE];
                }
                // Fetch difficulty levels and add to filters
                getDifficultyLevels().then((diffResponse: APIResponse) => {
                    if (diffResponse?.ResponseType == APIStatus.SUCCESS) {
                        data[FILTER_LIST.DIFFICULTY] = diffResponse?.data;
                    }
                    setFilters((prev: any) => ({
                        ...data,
                        [FILTER_LIST.CHAPTER]: prev?.[FILTER_LIST.CHAPTER] || [],
                        [FILTER_LIST.TOPIC]: prev?.[FILTER_LIST.TOPIC] || []
                    }));
                }).catch(() => {
                    setFilters((prev: any) => ({
                        ...data,
                        [FILTER_LIST.CHAPTER]: prev?.[FILTER_LIST.CHAPTER] || [],
                        [FILTER_LIST.TOPIC]: prev?.[FILTER_LIST.TOPIC] || []
                    }));
                });
            }
        })
    }

    function getAllTestSeriesList(param: any, pageNum: number = 1) {
        if (pageNum === 1) {
            setCurrentParams(param);
            setPage(1);
            setIsLoading(true);
        } else {
            setIsLoadingMore(true);
        }
        let extendPayload: any = {};
        if (location.pathname === TestSereisRouteURL.TEST_SERIES) {
            extendPayload.examType = 0;
        } else if (location.pathname === TestSereisRouteURL.FULL_MOCK_TEST_SERIES) {
            extendPayload.examType = 1;
        } else if (location.pathname === TestSereisRouteURL.DIAGNOSTIC_TEST_SERIES) {
            extendPayload.examType = 2;
        } else if (location.pathname === TestSereisRouteURL.PREVIOUS_YEAR_MOCK_TEST_SERIES) {
            extendPayload.examType = 3;
        }
        const payload = { ...param, page: pageNum, limit: 20, ...extendPayload };

        // Determine which API to use based on board matching
        let apiCall = getTestSeriesListAll; // Default API

        if (params.boardId) {
            // Extract the board ID from param
            const selectedBoardId = param[FILTER_KEYS.BOARD];
            const userPreferredBoardId = coursePreferences?.boardDetails?.[0]?.Id;

            // If selected board matches user's preferred board, use the filter API
            if (selectedBoardId && userPreferredBoardId && selectedBoardId === userPreferredBoardId) {
                apiCall = getTestSeriesList;
            } else {
                apiCall = getTestSeriesListAll;
            }
        } else {
            apiCall = getTestSeriesList;
        }

        apiCall(payload).then((response: APIResponse) => {
            if (response?.ResponseType == APIStatus.SUCCESS) {
                let data = response?.data;
                const newResults = data.result || [];
                setTotalRecords(data.total_record || 0);

                if (pageNum === 1) {
                    setTestDeatils(newResults);
                } else {
                    setTestDeatils(prev => [...prev, ...newResults]);
                }
                setIsLoading(false);
                setIsLoadingMore(false);
            } else {
                setIsLoading(false);
                setIsLoadingMore(false);
            }
        }).catch((error: any) => {
            setIsLoading(false);
            setIsLoadingMore(false);
        })
    }

    const handleLoadMore = () => {
        const nextPage = page + 1;
        setPage(nextPage);
        getAllTestSeriesList(currentParams, nextPage);
    }

    /* function getAllTestSeriesSearchFilters(param: any, updateInitial: boolean = false) {
        getTestSeriesSearchFilters(param).then((response: APIResponse) => {
            if (response?.ResponseType == APIStatus.SUCCESS) {
                let data = response?.data;

                // Merge board list from coursePreferences with API response
                if (coursePreferences?.boardDetails?.length > 0) {
                    const prefBoards = coursePreferences.boardDetails;
                    const apiBoards = data[FILTER_LIST.BOARD] || [];

                    const boardMap = new Map();
                    apiBoards.forEach((b: any) => boardMap.set(b.Id, b));
                    prefBoards.forEach((b: any) => {
                        if (!boardMap.has(b.Id)) {
                            boardMap.set(b.Id, b);
                        }
                    });
                    data[FILTER_LIST.BOARD] = Array.from(boardMap.values());
                }

                // Merge class list from coursePreferences with API response
                if (coursePreferences?.classDetails?.length > 0) {
                    const prefClasses = coursePreferences.classDetails;
                    const apiClasses = data[FILTER_LIST.CLASS] || [];

                    const classMap = new Map();
                    apiClasses.forEach((c: any) => classMap.set(c.Id, c));
                    prefClasses.forEach((c: any) => {
                        if (!classMap.has(c.Id)) {
                            classMap.set(c.Id, c);
                        }
                    });
                    data[FILTER_LIST.CLASS] = Array.from(classMap.values());
                }

                // Merge subject list from coursePreferences with API response
                if (coursePreferences?.subjectDetails?.length > 0) {
                    const prefSubjects = coursePreferences.subjectDetails;
                    const apiSubjects = data[FILTER_LIST.SUBJECT] || [];

                    const subjectMap = new Map();
                    apiSubjects.forEach((s: any) => subjectMap.set(s.Id, s));
                    prefSubjects.forEach((s: any) => {
                        if (!subjectMap.has(s.Id)) {
                            subjectMap.set(s.Id, s);
                        }
                    });
                    data[FILTER_LIST.SUBJECT] = Array.from(subjectMap.values());
                }
                if (updateInitial && loginData?.LanguageId) {
                    const langName = loginData.LanguageName || 'Language';
                    const lang = { Id: loginData.LanguageId, Name: langName };

                    setInitialFilters(prev => prev.map(f =>
                        f[FILTER_KEYS.LANGUAGE] ? { [FILTER_KEYS.LANGUAGE]: lang } : f
                    ));
                }

                // Patch names from Redux just in case
                if (data[FILTER_LIST.LANGUAGE] && loginData?.isLoggedIn) {
                    data[FILTER_LIST.LANGUAGE] = data[FILTER_LIST.LANGUAGE].map((l: any) => {
                        const patchedName = l.Name || (l.Id == loginData.LanguageId ? loginData.LanguageName : 'Language');
                        return { ...l, Name: patchedName };
                    });
                } else if (!loginData?.isLoggedIn) {
                    // For logged out users, don't use API language data, use our own
                    delete data[FILTER_LIST.LANGUAGE];
                }

                // Fetch difficulty levels and add to filters
                getDifficultyLevels().then((diffResponse: APIResponse) => {
                    if (diffResponse?.ResponseType == APIStatus.SUCCESS) {
                        data[FILTER_LIST.DIFFICULTY] = diffResponse?.data;
                    }

                    // Fetch test series list if class is selected
                    // if (param[FILTER_KEYS.CLASS]) {
                    //     getTestSeriesListByClass(param[FILTER_KEYS.CLASS]).then((tsResponse: APIResponse) => {
                    //         if (tsResponse?.ResponseType == APIStatus.SUCCESS) {
                    //             data[FILTER_LIST.TEST_SERIES] = tsResponse?.data;
                    //         }
                    //         setFilters((prev: any) => ({
                    //             ...prev,
                    //             ...data,
                    //             [FILTER_LIST.CHAPTER]: prev?.[FILTER_LIST.CHAPTER] || [],
                    //             [FILTER_LIST.TOPIC]: prev?.[FILTER_LIST.TOPIC] || []
                    //         }));
                    //     }).catch(() => {
                    //         setFilters((prev: any) => ({
                    //             ...prev,
                    //             ...data,
                    //             [FILTER_LIST.CHAPTER]: prev?.[FILTER_LIST.CHAPTER] || [],
                    //             [FILTER_LIST.TOPIC]: prev?.[FILTER_LIST.TOPIC] || []
                    //         }));
                    //     });
                    // } else {
                    setFilters((prev: any) => ({
                        ...prev,
                        ...data,
                        [FILTER_LIST.CHAPTER]: prev?.[FILTER_LIST.CHAPTER] || [],
                        [FILTER_LIST.TOPIC]: prev?.[FILTER_LIST.TOPIC] || []
                    }));
                    // }
                }).catch(() => {
                    setFilters((prev: any) => ({
                        ...prev,
                        ...data,
                        [FILTER_LIST.CHAPTER]: prev?.[FILTER_LIST.CHAPTER] || [],
                        [FILTER_LIST.TOPIC]: prev?.[FILTER_LIST.TOPIC] || []
                    }));
                });
            }
        })
    } */
    const submitFilters = (filters: any) => {

        if (!!topicPriority) {
            setBoardTotals(null)
        }
        setTopicPriority(undefined);
        let newFilters: any = { ...filters };
        // if(isTestSeries){
        // pass  source as array intead of string irrespective of the dropdown 
        if (newFilters[FILTER_KEYS.SOURCE] && newFilters[FILTER_KEYS.SOURCE].Id) {
            newFilters[FILTER_KEYS.SOURCE] = [newFilters[FILTER_KEYS.SOURCE]];
        }
        // }
        Object.keys(newFilters).map((filter: any) => {
            newFilters[filter] = newFilters[filter] != undefined || newFilters[filter] != null ? newFilters[filter] : delete newFilters[filter];
        });
        getHeadingFromSubmitFilters(filters);
        let params = modifiedFilters(newFilters);

        // Inject language ID if logged in
        if (loginData?.isLoggedIn && loginData?.LanguageId && !params.languageId) {
            params.languageId = [loginData.LanguageId];
        }

        // Inject default subject ids if on matched board and no subject selected
        const userBoardId = coursePreferences?.boardDetails?.[0]?.Id;
        if (params[FILTER_KEYS.BOARD] && userBoardId && String(params[FILTER_KEYS.BOARD]) === String(userBoardId)) {
            if (!params[FILTER_KEYS.SUBJECT]) {
                const subjectIds = coursePreferences?.subjectDetails?.map((s: any) => s.Id) || [];
                if (subjectIds.length > 0) {
                    params[FILTER_KEYS.SUBJECT] = subjectIds;
                }
            }
        }


        if (isTestSeries) {
            // getAllTestSeriesSearchFilters(params)
            getAllTestSeriesList(params, 1);
        } else {
            getAllSearchFilters(params);
            getAllTestList(params)
        }
    }

    // Add callback to update language list
    submitFilters.updateLanguages = (languageData: any[]) => {
        setFilters((prev: any) => ({
            ...prev,
            [FILTER_LIST.LANGUAGE]: languageData
        }));
    };

    // Add callback to update board list
    submitFilters.updateBoards = (boardData: any[]) => {
        setFilters((prev: any) => ({
            ...prev,
            [FILTER_LIST.BOARD]: boardData
        }));
    };

    // Add callback to update class list
    submitFilters.updateClasses = (classData: any[]) => {
        setFilters((prev: any) => ({
            ...prev,
            [FILTER_LIST.CLASS]: classData
        }));
    };

    // Add callback to update difficulty levels
    submitFilters.updateDifficultyLevels = (difficultyData: any[]) => {
        setFilters((prev: any) => ({
            ...prev,
            [FILTER_LIST.DIFFICULTY]: difficultyData
        }));
    };

    // Add callback to update test series list
    submitFilters.updateTestSeries = (testSeriesData: any[]) => {
        setFilters((prev: any) => ({
            ...prev,
            [FILTER_LIST.TEST_SERIES]: testSeriesData
        }));
    };

    // Add callback to update subjects
    submitFilters.updateSubjects = (subjectData: any[]) => {
        const isPrevOrFullMock = isPreviousYearPage || isFullMockPage;
        const finalSubjects = (isPrevOrFullMock && subjectData.length > 0 && !subjectData.some((s: any) => s.Id === 'ALL'))
            ? [{ Id: 'ALL', Name: 'All Subject' }, ...subjectData]
            : subjectData;
        setFilters((prev: any) => ({
            ...prev,
            [FILTER_LIST.SUBJECT]: finalSubjects
        }));
    };

    // Add callback to update chapter list
    submitFilters.updateChapters = (chapterData: any[]) => {
        setFilters((prev: any) => ({
            ...prev,
            [FILTER_LIST.CHAPTER]: chapterData
        }));
    };

    // Add callback to update topic list
    submitFilters.updateTopics = (topicData: any[]) => {
        setFilters((prev: any) => ({
            ...prev,
            [FILTER_LIST.TOPIC]: topicData
        }));
    };

    // Add callback to clear specific child lists
    submitFilters.clearChildLists = (childKeys: string[]) => {
        setFilters((prev: any) => {
            let updatedFilters = { ...prev };
            childKeys.forEach(key => {
                const listKey = (FILTER_KEY_LIST as any)[key];
                // Don't clear Difficulty and Language lists as they are fetched globally
                if (listKey && listKey !== FILTER_LIST.DIFFICULTY && listKey !== FILTER_LIST.LANGUAGE) {
                    updatedFilters[listKey] = [];
                }
            });
            return updatedFilters;
        });
    };

    // Add callback to clear all dependent filters (used on global clear)
    submitFilters.clearAllDependentFilters = () => {
        setFilters((prev: any) => ({
            ...prev,
            [FILTER_LIST.CHAPTER]: [],
            [FILTER_LIST.TOPIC]: [],
            [FILTER_LIST.TEST_SERIES]: []
        }));
    };

    const getHeadingFromSubmitFilters = (filters: any) => {
        let updatedBreadrumb: any = [];
        if (filters[FILTER_KEYS.CLASS] && filters[FILTER_KEYS.CLASS].Id) {
            let dataToPush = {
                type: HeaderNameKeys.CLASS,
                name: filters[FILTER_KEYS.CLASS].Name
            }
            updatedBreadrumb.push(dataToPush);
        }
        if (filters[FILTER_KEYS.SUBJECT] && filters[FILTER_KEYS.SUBJECT].Id) {
            let dataToPush = {
                type: HeaderNameKeys.SUBJECT,
                name: filters[FILTER_KEYS.SUBJECT].Name
            }
            updatedBreadrumb.push(dataToPush);
        }
        if (filters[FILTER_KEYS.TEST_SERIES] && filters[FILTER_KEYS.TEST_SERIES].Id) {
            let dataToPush = {
                type: HeaderNameKeys.ALL_TEST_SERIES,
                name: 'Test Series'
            }
            updatedBreadrumb.push(dataToPush);
            dataToPush = {
                type: HeaderNameKeys.TEST_SERIES,
                name: filters[FILTER_KEYS.TEST_SERIES].Name
            }
            updatedBreadrumb.push(dataToPush);
        }
        // setHeadingsBreadcrumb(updatedBreadrumb);
    }

    const modifiedFilters = (filters: any) => {
        let payload: any = {};
        let keys = Object.keys(filters);
        keys.forEach((key) => {
            if (key === 'previousYearCheck' && filters[key]) {
                payload[key] = filters[key];
            } else if (key === 'keyWord' && filters[key]) {
                payload[key] = filters[key];
            } else if (key === FILTER_KEYS.EXAM_YEAR) {
                if (Array.isArray(filters[key]) && filters[key].length > 0) {
                    payload[key] = filters[key]
                        .map((year: any) => String(year.Id))
                        .sort((a: string, b: string) => Number(a) - Number(b))
                        .join(',');
                } else if (filters[key]?.Id) {
                    payload[key] = String(filters[key].Id);
                }
            } else if (filters[key] && typeof (filters[key]) == 'object') {
                if (Array.isArray(filters[key])) {
                    if (filters[key].length > 0) {
                        payload[key] = filters[key].map((filter: any) => {
                            return filter.Id
                        })
                    }
                } else {
                    if (filters[key].Id !== undefined && filters[key].Id !== null) {
                        if (key === FILTER_KEYS.TEST_SERIES) {
                            payload['testSeriesId'] = Number(filters[key].Id);
                        } else if (key === FILTER_KEYS.SUBJECT && filters[key].Id === 'ALL') {
                            const allSubjectIds = coursePreferences?.subjectDetails?.map((s: any) => s.Id) || [];
                            payload[FILTER_KEYS.SUBJECT] = allSubjectIds;
                        } else if (key === FILTER_KEYS.DIFFICULTY || key === FILTER_KEYS.CHAPTER || key === FILTER_KEYS.TOPIC || key === FILTER_KEYS.LANGUAGE || key === FILTER_KEYS.SUBJECT) {
                            payload[key] = [filters[key].Id];
                        } else {
                            payload[key] = filters[key].Id;
                        }
                    }
                }
            }
        });
        return payload
    }

    useEffect(() => {
        if (!(location.state?.topicPriority)) {
            setTopicPriority(null);
        }
    }, [location])

    const helmetProps = [
        {
            tagType: "title",
            content: {
                title: `${boardName}`
            }
        },
        {
            tagType: "meta",
            content: {
                name: "description",
                content: `${boardId}`
            }
        },



    ]
    return (
        <>
            {/* <HelmetComponent props={helmetProps} /> */}
            <HomeLayout >
                {/* <!-----------------------------------test-listining-section-------------------------------> */}
                <div className="test-listining">
                    <DetailsPageBanner Headings={headingsBreadcrumb} topicPriority={topicPriority} />
                    {boardTotals && (
                        (!topicPriority && !location.state?.topicName) &&
                        <div className="board-stats-container">

                            <div className="stat-card pending">
                                <div className="stat-icon">
                                    <SvgIcon name="mockTest" size={32} />
                                </div>
                                <div className="stat-content">
                                    <h2 className="stat-number">{isLoading ? '...' : totalRecords}</h2>
                                    <p className="stat-label">Total Tests</p>
                                </div>
                            </div>

                            <div className="stat-card total">
                                <div className="stat-icon">
                                    <SvgIcon name="classMaster" size={32} />
                                </div>
                                <div className="stat-content">
                                    <h2 className="stat-number">{boardTotals.totalStudents}</h2>
                                    <p className="stat-label">Total Students</p>
                                </div>
                            </div>

                            <div className="stat-card completed">
                                <div className="stat-icon">
                                    <SvgIcon name="subjectMaster" size={32} />
                                </div>
                                <div className="stat-content">
                                    <h2 className="stat-number">{boardTotals.totalAttendents}</h2>
                                    <p className="stat-label">Total Attempts</p>
                                </div>
                            </div>
                        </div>
                    )}
                    {filters ? (
                        (boardId && coursePreferences?.boardDetails?.[0]?.Id && String(boardId) === String(coursePreferences.boardDetails[0].Id)) ? (
                            <TestSeriesAllFilter
                                filters={{
                                    ...filters,
                                    [FILTER_LIST.BOARD]: filters[FILTER_LIST.BOARD] || coursePreferences?.boardDetails || [],
                                    [FILTER_LIST.CLASS]: filters[FILTER_LIST.CLASS] || coursePreferences?.classDetails || [],
                                    [FILTER_LIST.SUBJECT]: coursePreferences?.subjectDetails || [],
                                }}
                                submitFilters={submitFilters}
                                initialFilters={initialFilters}
                                mockTestSeriesList={testDeatils}
                                topicPriority={topicPriority}
                            />
                        ) : (
                            <FilterIndex filters={filters} submitFilters={submitFilters} initialFilters={initialFilters} isTestSeries={isTestSeries} isSpecificTestSeries={!!testSeriesId} isBoardPage={!!boardId} currentBoardId={boardId} boardDetailsData={boardDetailsData} testDeatils={testDeatils} isPreviousYearPage={isPreviousYearPage} isDiagnosticPage={isDiagnosticPage} isFullMockPage={isFullMockPage} />
                        )
                    ) : ""}
                    {isLoading && isTestSeries ? (
                        <TestSeriesSkeleton />
                    ) : (
                        <MockTests
                            testList={testDeatils}
                            classId={classId}
                            subject={headingsBreadcrumb.find((h: any) => h.type === HeaderNameKeys.SUBJECT)?.name || subjectName}
                            isTestSeries={isTestSeries}
                            onLoadMore={handleLoadMore}
                            hasMore={testDeatils.length < totalRecords}
                            loading={isLoadingMore}
                            isBoardPage={!!boardId}
                            currentBoardId={boardId}
                            currentBoardName={boardName}
                            topicPriority={topicPriority}
                        />
                    )}
                    <SubscriptionUpdates />
                </div>

                {/* <!----------------------------------end-test-listining-section------------------------------->  */}
            </HomeLayout>

        </>
    );
}